import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Link } from "react-router-dom";

const CardVerifiedSnackbar = ({ open, onClose }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        marginTop: "5vh",
        position: "fixed",
      }}
    >
      <Alert
        severity="error"
        variant="filled"
        action={
          <IconButton
            size="1px"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Box>
        No credit card linked. Please{" "}
          <Link
            to="/card-details"
            style={{
              textDecoration: "underline",
              color: "white",
              cursor: "pointer",
            }}
          >
            click here to go to Card Details
          </Link>{" "}
          view to add one.
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default CardVerifiedSnackbar;
